import { useQuery } from "@apollo/client";
import type { Project } from "@casey/db-types";
import { GET_ORGANIZATION_PROJECTS } from "../gql";

interface OrganizationProjectsResponse {
  projects: {
    nodes: Array<Project | null>;
  };
}

interface OrganizationProjectsVariables {
  organizationId: string;
}

export function useOrganizationProjects(organizationId?: string) {
  const { data, loading, error, refetch } = useQuery<
    OrganizationProjectsResponse,
    OrganizationProjectsVariables
  >(GET_ORGANIZATION_PROJECTS, {
    variables: { organizationId: organizationId || "" },
    skip: !organizationId,
    errorPolicy: "all",
  });

  const projects =
    data?.projects?.nodes?.filter((p): p is Project => p !== null) || [];

  return {
    projects,
    loading,
    error,
    refetch,
  };
}

export type { Project };
